<script lang="ts">
  import RequiresRetailerUserAuthenticationBanner from "@shared/svelte/Components/ProductLines/RequiresRetailerUserAuthenticationBanner.svelte";
  import { Button, Icon } from "@getprovi/craft-svelte";
  import { BoxArrowUpRight } from "@getprovi/craft-svelte-icons";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let authStatus: string;
  export let authService: any;
</script>

<div class="craft" data-testid="vermont-banner">
  <RequiresRetailerUserAuthenticationBanner retailerUserAuthStatus={authStatus} {authService}>
    <div slot="pending-title"> Access High Proof Spirits & Liquor! </div>

    <div slot="pending-description">
      Use your myVermont DLL Account to access products from Vermont!
    </div>

    <div slot="pending-buttons">
      <Button on:click={() => authService?.startVerification?.(authStatus)} size="sm"
        >Verify Account</Button
      >
    </div>

    <div slot="invalid-description">
      If there are issues, please call the Vermont Department of Liquor and Lottery at
      <a href="tel:+18028282345">802-828-2345</a>.
    </div>

    <div slot="invalid-buttons">
      <a
        href={authService.loginUrl()}
        target="_blank"
        rel="noreferrer"
        class="craft-button btn-primary btn-base justify-center"
        style="border-radius: 32px;"
        on:click={() => {
          loginEvent(authStatus, VT_802_SPIRITS_DISTRIBUTOR_ID);
          authService.refresh();
        }}
        data-testid="reconnect-account-button"
      >
        <span class="btn-text flex gap-4">Verify Account <Icon iconName={BoxArrowUpRight} /></span>
      </a>
    </div>
  </RequiresRetailerUserAuthenticationBanner>
</div>
